<div id="managePopUp">
    <div class="modal-header">
        <span class='modal-title' *ngIf="header">{{header}}</span>
    </div>

    <div class="modal-body">
            <p class="message"> {{footer}}</p>

        <div class="row row-style">
            <div class='btn-on-off'>
                <button type='button' class="col-style w-50" (click)="onClickAction(true)" [ngClass]="{'active-on': isActionOn === true}">{{actionOn}}</button>
                <button class='btn-border w-50' type='button' (click)="onClickAction(false)" [ngClass]="{'active-off': isActionOn === false}">{{actionOff}}</button>
            </div>
        </div>

        <div class="modal-footer pull-right popup_btnbox bottom_aligner">
            <div class='btnFullWidth'>
                <button type='button' class='secondary_btn' (click)="onClickCancel()"
                    *ngIf="ctaCancel">{{ctaCancel}}</button>
            </div>
            <div class='btnFullWidth'>
                <button type='button' class='primary_btn' (click)="onClickSubmit()" [disabled]="!isSubmitEnabled">{{ctaSubmit}}</button>
            </div>
        </div>

    </div>